export * from './inventory-manager-request-list.component';
export * from './inventory-manager-request-view.component';